import React from "react";
import { RingLoader } from "react-spinners"; // import style from './SpinnerA.module.css'

export default function RingLoaderB({ size }) {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: "1000",
        // width: "100%",
        top: "30%",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <RingLoader color="#9933cc" size={200} speedMultiplier={1} />
    </div>
  );
}
